import { render, staticRenderFns } from "./KegList.vue?vue&type=template&id=b196b94c"
import script from "./KegList.vue?vue&type=script&lang=js"
export * from "./KegList.vue?vue&type=script&lang=js"
import style0 from "./KegList.vue?vue&type=style&index=0&id=b196b94c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports